import loading from './loading.js';

export { loading };